import { render, staticRenderFns } from "./memo.vue?vue&type=template&id=aaf794c6&scoped=true&"
import script from "./memo.vue?vue&type=script&lang=js&"
export * from "./memo.vue?vue&type=script&lang=js&"
import style0 from "./memo.vue?vue&type=style&index=0&id=aaf794c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf794c6",
  null
  
)

export default component.exports